enum EnergyPriceType {
  SPOT = 'spot',
  FIXED = 'fixed'
}

export default EnergyPriceType
